module.exports = __webpack_public_path__ + "img/evileyetalisman.24e5db69.png";